import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: {
                    table: "Tabla"
                }
            }
        },
        lng: 'es', // Idioma predeterminado
        fallbackLng: 'es', // Idioma de respaldo si no se puede determinar el idioma del usuario
        interpolation: {
            escapeValue: false, // no escapar HTML dentro de cadenas de texto
        },
    })

export default i18n;